import type { RouteLocationNormalized } from "vue-router"

function rootLocation(route: RouteLocationNormalized) {
  return route.path.split("/")[1]
}

export function contentMenuVisible(route: RouteLocationNormalized) {
  return ![
    "video",
    "e-gramatas",
    "darba-lapas",
    "metodiskie-lidzekli",
    "interaktivie-materiali",
    "parbaudes-darbi",
    "visi-resursi",
  ].includes(rootLocation(route))
}

export function isEbookSection(route: RouteLocationNormalized) {
  return rootLocation(route) === "e-gramatas"
}

export function isTeachingAidsSection(route: RouteLocationNormalized) {
  return rootLocation(route) === "metodiskie-lidzekli"
}

export function isVideoSection(route: RouteLocationNormalized) {
  return rootLocation(route) === "video"
}

export function isActivInspireSection(route: RouteLocationNormalized) {
  return rootLocation(route) === "interaktivie-materiali"
}

export function productFiltersVisible(route: RouteLocationNormalized) {
  return rootLocation(route) !== "visi-resursi" && route.path.split("/").length < 3 && !contentMenuVisible(route)
}

export function pdfContentMenuVisible(route: RouteLocationNormalized) {
  return route.path.split(/\/|\?/)[3] === "pdf"
}
